module.exports = __webpack_public_path__ + "img/color-dynamics-2_cn.ea14572.jpg";